import R from 'app/assets/R'
import { SvgRefundAmountIcon } from 'app/assets/svg-assets'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { useTranslation } from 'react-i18next'
import { ModalComponent } from '../../components'
import BaseText from 'app/components/common/BaseText'

export const RefundAmountModal = () => {
  const { t } = useTranslation()

  return (
    <ModalComponent
      iconOpenModal={<SvgRefundAmountIcon />}
      titleOpenModal={t(R.strings.refund_money)}
      titleModal={t(R.strings.refund_money)}
      renderContent={
        <BaseSpace>
          <BaseText children={'Khánh'} />
        </BaseSpace>
      }
    />
  )
}
